@if (categories$ | async; as categories) {
  <section class="subcategories">
    <h2 class="head-underline__turquoise">{{ categories?.name }}</h2>
    @if (categories.subcategories.length) {
      @if (switcher$ | async; as switcher) {
        <div class="subcategories--list">
          @for (category of categories?.subcategories | slice: switcher.shownFromIndex:switcher.shownToIndex;
            track category.id) {
            <dp-product-subcategory [category]="category"></dp-product-subcategory>
          }
        </div>
        @if (switcher.totalLists > 1) {
          <dp-product-subcategory-switcher
            [switcher]="switcher" (changeActive)="setActive($event)"
          ></dp-product-subcategory-switcher>
        }
      }
    }
  </section>
}
